const plans = [
  {
    name: 'Starter',
    price: 'R 499',
    period: '/month',
    vat: 'excl. VAT',
    description: 'Perfect for small auto parts stores or single-bay workshops.',
    features: [
      '1 location',
      'Up to 5 users',
      '5,000 SKU limit',
      'Basic inventory management',
      'Customer portal',
      'Email support',
    ],
    cta: 'Start Free Trial',
    highlight: false,
    badge: null,
  },
  {
    name: 'Professional',
    price: 'R 999',
    period: '/month',
    vat: 'excl. VAT',
    description: 'Ideal for growing workshops and multi-staff parts dealers.',
    features: [
      'Up to 3 locations',
      'Unlimited users',
      '50,000 SKUs',
      'Full inventory + supplier module',
      'Vehicle history tracking',
      'WhatsApp + email alerts',
      'POS integration',
      'Priority support',
    ],
    cta: 'Book Demo',
    highlight: true,
    badge: 'Most Popular',
  },
  {
    name: 'Enterprise',
    price: 'Custom',
    period: '',
    vat: 'Contact us',
    description: 'For large dealerships, franchise groups, and multi-branch chains.',
    features: [
      'Unlimited locations',
      'Unlimited users & SKUs',
      'Dedicated account manager',
      'Custom integrations & API',
      'SLA guarantee',
      'On-site training',
      'White-label option',
    ],
    cta: 'Contact Sales',
    highlight: false,
    badge: null,
  },
];

const Pricing = () => {
  return (
    <section className="bg-[#060f1e] py-24 px-6" id="pricing">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/5 border border-white/10 rounded-full mb-5">
            <i className="ri-price-tag-3-line text-[#f97316] text-sm"></i>
            <span className="text-gray-300 text-xs font-semibold tracking-widest uppercase">Simple Pricing</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" style={{ fontFamily: "'Poppins', sans-serif" }}>
            Plans for Every Size Business
          </h2>
          <p className="text-gray-400 text-base max-w-xl mx-auto">
            All prices in South African Rand (ZAR), VAT-exclusive. 14-day free trial on all plans. No credit card required.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {plans.map((plan, i) => (
            <div
              key={i}
              className={`relative rounded-2xl p-8 flex flex-col border transition-all duration-300 ${
                plan.highlight
                  ? 'bg-gradient-to-b from-[#1e3a5f] to-[#0f2040] border-[#3b82f6]/50 shadow-xl shadow-[#3b82f6]/10'
                  : 'bg-[#0a1628] border-white/10 hover:border-white/20'
              }`}
            >
              {plan.badge && (
                <div className="absolute -top-4 left-1/2 -translate-x-1/2 px-4 py-1 bg-[#f97316] rounded-full text-white text-xs font-bold whitespace-nowrap">
                  {plan.badge}
                </div>
              )}

              <div className="mb-6">
                <h3 className="text-lg font-bold text-white mb-1" style={{ fontFamily: "'Poppins', sans-serif" }}>{plan.name}</h3>
                <p className="text-gray-400 text-sm mb-5">{plan.description}</p>
                <div className="flex items-end gap-1">
                  <span className="text-3xl font-bold text-white" style={{ fontFamily: "'Poppins', sans-serif" }}>{plan.price}</span>
                  {plan.period && <span className="text-gray-400 text-sm mb-1">{plan.period}</span>}
                </div>
                <span className="text-gray-500 text-xs">{plan.vat}</span>
              </div>

              <ul className="space-y-3 flex-1 mb-8">
                {plan.features.map((feat, j) => (
                  <li key={j} className="flex items-center gap-3 text-gray-300 text-sm">
                    <div className="w-5 h-5 flex items-center justify-center bg-[#3b82f6]/15 rounded-full flex-shrink-0">
                      <i className="ri-check-line text-[#3b82f6] text-xs"></i>
                    </div>
                    {feat}
                  </li>
                ))}
              </ul>

              <a
                href="#demo"
                className={`inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg font-semibold text-sm transition-all duration-200 whitespace-nowrap ${
                  plan.highlight
                    ? 'bg-[#f97316] hover:bg-[#ea6c0a] text-white'
                    : 'bg-white/10 hover:bg-white/15 border border-white/15 text-white'
                }`}
              >
                {plan.cta}
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm">
            All plans include VAT invoicing, South African Rand currency support, and SARS-compliant reporting.
            <a href="#demo" className="text-[#3b82f6] hover:text-[#f97316] ml-1 transition-colors cursor-pointer">Compare all features →</a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
